import './css/app.css';
import { picoapp } from 'picoapp';
import ready from 'utils/ready';

import cartDrawer from 'layout/cart-drawer'; // eslint-disable-line
import cartItem from 'components/cart-item'; // eslint-disable-line
import harmonicaItem from 'components/harmonica-item';
import klaviyoSection from 'components/klaviyo-section';
import header from 'layout/header';
import hero from 'components/hero';
import languageSelect from 'layout/language-select';
import mobileNav from 'layout/mobile-nav';
import productItem from 'components/product-item';
import window from 'global/window';
import wishlistCount from 'components/wishlist-count';

const app = picoapp({
  cartDrawer,
  cartItem,
  harmonicaItem,
  klaviyoSection,
  header,
  hero,
  languageSelect,
  mobileNav,
  productItem,
  wishlistCount,
}, {
  cart: theme.cart,
});

window(app);
ready(app.mount);

export default app;
